import { Row, Col, Card, Table, DatePicker, Tag, Button } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import moment from 'moment';
import ShowTotal from "../../components/ShowTotal";
import apiPath from "../../constants/apiPath";
import { useParams } from "react-router-dom";
import lang from "../../helper/lang";
import FilterBar, { FilterBarFilters } from "../../components/FilterBar";

const { RangePicker } = DatePicker;

function Activity() {

  const sectionName   =   lang("Activity");
  const params        =   useParams();

  const api = {
    list: apiPath.activity,
  }

  const handleGoBack = () => {
    window.history.back();
  }

  const { request } = useRequest()
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [showFilters, setShowFilters] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const columns = [
    {
      title: `${lang('User')} ${lang('Name')}`,
      dataIndex: "user",
      key: "user",
      render: (_, { user, _id }) => {
        return user && user.name ? <span className="cap text-info"> {user.name} </span> : '-' ;
      },
    },
    {
      title: `${lang('Platform')}`,
      dataIndex: "device_type",
      key: "device_type",
      render: (_, { device_type }) => {
        return device_type ? <Tag color={'cyan'}><span className="cap">{device_type}</span></Tag> : '-';
      },
    },
    {
      title: `${lang('Logged')} ${lang('In')}`,
      key: "logged_in",
      dataIndex: "logged_in",
      render: (_, { logged_in }) => {
        return logged_in ? moment(logged_in).format('DD-MMM-YYYY HH:mm A') : '-';
      },
    },
    {
      title: `${lang('Logged')} ${lang('Out')}`,
      key: "logged_out",
      dataIndex: "logged_out",
      render: (_, { logged_out }) => {
        return logged_out ? moment(logged_out).format('DD-MMM-YYYY HH:mm A') : '-';
      },
    },
    {
      title: `${lang('Current')} ${lang('Status')}`,
      key: "logged_in",
      dataIndex: "logged_in",
      render: (_, { logged_out, _id }) => {
        let color   =   (logged_out == '' || logged_out == null) ? 'green' : 'red';
        return ( <Tag  color={color} key={_id}> { (logged_out == '' || logged_out == null) ? 'Available' : 'Not Available' } </Tag> )
      },
    },
  ];

  useEffect(() => {
    setLoading(true)
    fetchData(pagination)
  }, [refresh, startDate, endDate])

  const fetchData = (pagination) => {
    request({
      url: api.list + `?userId=${params.id}&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10}&start_date=${startDate ? startDate : ""}&end_date=${endDate ? endDate : ""}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false)
        setList(data.data.list.docs)
        setPagination(prev => ({ current: pagination.current, total: data.data.list.totalDocs, pageSize: Number(data.data.list.limit) }))
      },
      onError: (error) => {
        console.log(error)
        setLoading(false)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const handleChange = (pagination) => {
    fetchData(pagination);
  }

  const handleChangeDate = (e) => {
    setPagination({ current: 1, pageSize: pagination.pageSize })
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"))
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"))
    } else {
      setStartDate()
      setEndDate()
    }
  };

  return (
    <>
      <div className="tabled customerMain">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + ` ${lang("Manager")}`}
              extra={
                <FilterBar
                  showFilters={showFilters}
                  onToggle={() => setShowFilters((v) => !v)}
                  rightContent={
                    <Button onClick={(e) => handleGoBack()}>
                      <i className="fas fa-arrow-left"></i>&nbsp;&nbsp;{lang("Back")}
                    </Button>
                  }
                />
              }
            >
              {showFilters && (
                <FilterBarFilters>
                  <RangePicker
                    disabledDate={(current) => current.isAfter(Date.now())}
                    onChange={handleChangeDate}
                  />
                </FilterBarFilters>
              )}
              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{ current: pagination.current, defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50'] }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}
export default Activity;
